import { createFileRoute } from "@tanstack/react-router";
import PremeraInsurance, { config } from "@/pages/PremeraInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/premera-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Premera Blue Cross TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Have Premera Blue Cross? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Premera plan in Coral.",
        },
        {
          property: "og:title",
          content: "Premera Blue Cross TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Have Premera Blue Cross? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Premera plan in Coral.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/premera-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/premera-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <PremeraInsurance />;
}
